import React, { lazy, Suspense } from 'react';
import NavigationControls from '../components/common/NavigationControls';
import CursorFollower from '../components/common/CursorFollower';
import BackgroundMusic from '../components/common/BackgroundMusic';
import UnderConstructionBanner from '../components/common/UnderConstructionBanner';
import BotWidget from '../components/common/BotWidget';
import NowWidget from '../components/common/NowWidget';
import { useFeatureFlags } from '../hooks/useFeatureFlags';

const Home = lazy(() => import('../components/sections/Home'));
const About = lazy(() => import('../components/sections/About'));
const Projects = lazy(() => import('../components/sections/Projects'));
const Showcase = lazy(() => import('../components/sections/Showcase'));
const Contact = lazy(() => import('../components/sections/Contact'));

function LoadingFallback() {
  return (
    <div className="app-loading" aria-live="polite" aria-busy="true">
      <span className="app-loading__ring" />
    </div>
  );
}

function AppShell() {
  const flags = useFeatureFlags();

  return (
    <div className="App app-shell">
      {flags.underConstruction ? <UnderConstructionBanner /> : null}
      <NavigationControls />

      <main className="site-main" id="site-main" aria-label="Portfolio principal">
        <Suspense fallback={<LoadingFallback />}>
          <Home />
        </Suspense>
        <Suspense fallback={null}>
          <About />
        </Suspense>
        <Suspense fallback={null}>
          <Projects />
        </Suspense>
        <Suspense fallback={null}>
          <Showcase />
        </Suspense>
        <Suspense fallback={null}>
          <Contact />
        </Suspense>
      </main>

      {flags.cursorFollower ? <CursorFollower /> : null}
      {flags.backgroundMusic ? <BackgroundMusic /> : null}
      {flags.botWidget ? <BotWidget /> : null}
      {flags.nowWidget ? <NowWidget /> : null}
    </div>
  );
}

export default AppShell;
